import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../../App.css'


function InfoExperimentalProcedureViewer(props){

    // const modules = {
    //     toolbar: [
    //         [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    //         [{ 'header': [1, 2, 3, 4, 5] }],
    //         ['bold', 'italic', 'underline', 'strike'],
    //         [{ 'color': ['black','#80002A', '#440119', '#FFB3CA', '#0fba9c', '#C6FAF1', 
    //                              '#091EB7', '#C2C9FC', '#BFBFBF', '#7F7F7F', '#E4E4E4'] }],
    //         [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    //         [{ 'script': 'sub' }, { 'script': 'super' }],
    //         [{ 'indent': '-1' }, { 'indent': '+1' }],
    //         ['link', 'image'],
    //     ],
    //     clipboard: {
    //         matchVisual: false
    //     }
    // };

    const modules_none = {
        toolbar: null,
    };


    return(<>
            <h4 style = {{'margin':'0', marginBottom:'0px', marginTop:'10px', fontSize:'14px', padding:'0px', marginLeft: '0px', position: 'relative', width: `${props.width * 0.89 - 60}px`}} >Description Experimental Procedure</h4> 
            <div style={{fontSize:'14px', marginTop:'5px', marginLeft:'0px'}}>Experimental Setup: {props.uuidExpSetup}</div>
            <div style = {{'margin':'0', marginBottom:'15px', marginTop:'10px', 'padding':'0px', marginLeft: '0px', position: 'relative', width:'100%', maxHeight:'400px', overflow:'auto'}}>
                <ReactQuill readOnly={true} modules={modules_none} theme="snow" value={props.description} onChange={props.handleDescription} />
            </div>
    </>);
}


export default InfoExperimentalProcedureViewer
